import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { Shield } from '@mui/icons-material';

interface Props {
  status: number; // 1 = активний, 2 = заблокований, 3 = видалений
  isProtectedDemoAccount?: boolean;
}

const STATUS_CONFIG: Record<number, { label: string; color: 'success' | 'warning' | 'error' }> = {
  1: { label: 'Активний', color: 'success' },
  2: { label: 'Заблокований', color: 'warning' },
  3: { label: 'Видалений', color: 'error' },
};

// Замінює колишній UserStatusIcon (хибно вважав "0 = заблокований" замість
// реальних 1/2/3) — і розрізнені інлайн-Chip у списках/деталях клієнтів/
// експертів, які показували block(2) і видалення(3) однаково.
//
// isProtectedDemoAccount — окрема, незалежна від status позначка: акаунт,
// захищений від самостійного видалення (demo для App Store/Google Play
// review). Раніше ніде в адмінці не було видно, які акаунти захищені.
export const UserStatusChip: React.FC<Props> = ({ status, isProtectedDemoAccount }) => {
  const config = STATUS_CONFIG[status] ?? { label: `Статус ${status}`, color: 'warning' as const };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      <Chip label={config.label} color={config.color} size="small" variant="outlined" />
      {isProtectedDemoAccount && (
        <Tooltip title="Захищений demo-акаунт — самостійне видалення заборонено">
          <Chip
            icon={<Shield fontSize="small" />}
            label="Захищений"
            color="info"
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
    </Box>
  );
};
